export default __webpack_public_path__ + "static/media/SD-veda-ashirvachanam-img.7acfac3b.png";